export class BlockGroup{
    blockId: number;
    grupoId: number;
    institucionId: string;
}